<template>
    <div>
        <img src="@/m/images/campus-bg.png" width="100%">
        <!--{{types}}-->
        <yd-tab horizontal-scroll active-color="#369567" :callback="setType" v-if="types.length">
            <yd-tab-panel label="全部"></yd-tab-panel>
            <yd-tab-panel v-for="(type, i) in types" :key="i" :label="type.tag_name"></yd-tab-panel>
        </yd-tab>
        <div class="search-box">
            <yd-search v-model="nowKey" :on-submit="search" @on-click = 'search' @on-enter="search" placeholder="请输入职位关键词" cancel-text=''></yd-search>
            <div class="search-city">
                <yd-button type="hollow" shape="circle" size="large" @click.native="showPickerCity">
                   {{nowCity.tag_name}}
                </yd-button>
            </div>
            <div style="clear:both;"></div>
        </div>
        <yd-infinitescroll :callback="getData" ref="infinitescroll">
            <ul class="post-list" slot="list" >
                    <li v-for="(work,i) in works" :key="i" @click="goto(work.id)">
                        <!-- <router-link :to="'campus/detail/'+work._id"> -->
                            <p class="post-title">
                                {{work.job_name}}
                                <span>{{work.salary}}</span>
                            </p>
                            <p class="place">
                                <em v-for="(place,num) in work.job_places">
                                    {{place}}
                                    <span v-if="num < work.job_places.length - 1">|</span>
                                </em>
                            </p>
                            <p class="need">
                                {{work.edu}}
                                <span>|</span>
                                发布于{{work.update_at}}
                            </p>
                        <!-- </router-link> -->
                    </li>
            </ul>

            <!-- 数据全部加载完毕显示 -->
            <span slot="doneTip">啦啦啦，没有数据啦~~</span>
            <!-- 加载中提示，不指定，将显示默认加载中图标 -->
            <!-- <img slot="loadingTip" src="@/m/images/loading.svg"/> -->
        </yd-infinitescroll>
        <awesome-picker
                v-if="pickerCity.data.length"
                ref="pickerCity"
                :textTitle="pickerCity.textTitle"
                :data="pickerCity.data"
                :anchor="pickerCity.anchor"
                @confirm="handlePickerCityConfirm">
        </awesome-picker>
    </div>
</template>
<script>
   export default {
        data() {
            return {
                types:[],
                works:{},
                nowPage:1,
                allPage:1,
                nowCity: {
                    id: '',
                    tag_name: '全部'
                },
                nowType: '',
                nowKey: '',
                citys: [],
                pickerCity: {
                            anchor: [],
                            textTitle: '城市选择',
                            data: []
                        }
            }
        },
        methods: {
            getLabelList() {
                this.$axios.get(this.api.getLabelList,{
                    params: { entry_id: this.$route.params.entry_id || 0 }
                })
                    .then(res=>{
                        this.types = res.data.types;
                        this.citys = res.data.citys;
                        this.pickerCity.data = [res.data.citys.map( item =>{
                            return item.tag_name
                        })]
                    })
            },
            getData(){
                this.$axios.get(this.api.getCampusData,{
                    params: {
                        page: this.nowPage,
                        city: this.nowCity.id,
                        type: this.nowType,
                        key: this.nowKey,
                        entry_id: this.$route.params.entry_id || 0
                    }
                })
                    .then(res=>{
                        if(res.data.current_page == 1){
                            this.works = res.data.data;
                        }else{
                            this.works = this.works.concat(res.data.data);
                        }

                        this.allPage = res.data.last_page;
                        if( this.nowPage == this.allPage){
                             /* 所有数据加载完毕 */
                            this.$refs.infinitescroll.$emit('ydui.infinitescroll.loadedDone');
                            return;
                        }
                            /* 单次请求数据完毕 */
                        this.$refs.infinitescroll.$emit('ydui.infinitescroll.finishLoad');
                        this.nowPage++;
                    })
            },
            goto(id){
                this.$router.push({name:'cdetail',params:{entry_id: this.$route.params.entry_id,id: id}});
            },
            setType(type){
                if(type === '全部'){
                    this.nowType = ''
                }else {
                    this.types.forEach( item =>{
                        if(item.tag_name === type) this.nowType = item.id
                    })
                }
                this.nowKey = '';
                this.nowCity = {
                    id:'',
                    tag_name: '全部'
                };
                this.nowPage = 1;
                this.getData();
            },
            search(value) {
                this.nowKey = value;
                this.nowPage = 1;
                // this.$dialog.toast({mes: `搜索：${value}`});
                this.getData();
            },
           showPickerCity () {
                this.$refs.pickerCity.show()
            },
            handlePickerCityConfirm (v) {
                this.pickerCity.anchor = v;
                this.nowCity = this.citys[v[0].index]
                this.nowPage = 1;
                this.getData();
            }
        },
        created() {
            this.getLabelList();
            this.getData();
        }
    }
</script>
<style scoped>
img{
    display: block;
}
</style>
<style>
    .yd-tab-nav-item a:hover{
        color:#369567;
    }
.search-box{
    padding:0 .24rem;
    border-bottom:1px solid #ddd;
}
.yd-search{
    float: left;
    width: 70%;
}
.search-city{
    width: 20%;
    float: right;
}
.search-city button{
    color:#939393;
    margin-top:0;
    height: .55rem;
    font-size:.24rem;
    margin-top:.16rem;
    background:url(../../images/arrow.png) right center no-repeat;
}
.yd-search .yd-search-input{
    background-color:#fff;
}
.yd-search-input>.search-input{
    background-color:#f2f2f2;
    border-radius:50px;
}
.post-list{
    padding:0 .24rem;
}
.post-list li{
    padding:.24rem 0;
    border-bottom:1px solid #ededec;
}
.post-title{
    font-size:.28rem;
}
.post-title span{
    color:#369567;
    float: right;
}
.place{
    color:#7f8382;
    font-size:.24rem;
    line-height:.5rem;
}
.need{
    color:#939393;
}
.yd-search-input:before,.yd-search-input:after{
    border:none;
}
.yd-search-input{
    padding:10px 0 10px 0;
}
</style>


